import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
	function initializeSimpleSlider(selector) {
		const sliderElements = document.querySelectorAll(selector);
		// If Sliderelemnt can not be find, exit the function
		if (!sliderElements.length) return;

		if (sliderElements.length > 0) {
			sliderElements.forEach(function (sliderElement) {
				let splideInstance; // Declare splideInstance here, in the forEach loop's scope

				if (sliderElement.splide) {
					// Check if a Splide instance already exists on sliderElement and destroys it before initializing a new one.
					sliderElement.splide.destroy();
				}

				// Prevent duplicate initialization
				if (sliderElement.classList.contains("is-initialized")) return;
				sliderElement.classList.add("is-initialized");

				const slides = sliderElement.querySelectorAll(".splide__slide");
				const shouldAutoplay =
					sliderElement.classList.contains("autoplay");

				//
				// Initialize Splide slider and store the instance
				//
				splideInstance = new Splide(sliderElement, {
					type: "fade",
					perPage: 1,
					perMove: 1,
					rewind: true,
					arrows: false,
					gap: "2rem",
					pagination: slides.length > 1, // enable only if more than 1 slide
					mediaQuery: "min",
					autoplay: shouldAutoplay,
					breakpoints: {
						768: {
							perPage: 1,
							gap: "2.4rem",
						},
						1200: {
							perPage: 1,
						},
						1500: {
							perPage: 1,
						},
					},
				});

				// If pagination is enabled, convert dots to numbers.
				// IMPORTANT: Register event listener BEFORE mount()
				if (
					slides.length > 1 &&
					sliderElement.classList.contains(
						"pagination-fractional-list"
					)
				) {
					splideInstance.on("pagination:mounted", function (data) {
						// `data.items` contains all dot items.
						data.items.forEach(function (item) {
							item.button.textContent = `${item.page + 1} / ${
								data.items.length
							}`;
						});
					});
				}

				// Mount the slider after event listeners are registered
				splideInstance.mount();

				//
				// If custom arrows need to be added
				//
				const customArrowsContainer =
					sliderElement.querySelector(".custom-arrows");
				if (customArrowsContainer) {
					if (slides.length <= 1) {
						// Hide arrows if there's only one (or zero) slide.
						customArrowsContainer.style.display = "none";
					} else {
						// This fallback logic creates buttons if they don't exist in the DOM.
						if (
							!customArrowsContainer.querySelector(".custom-prev")
						) {
							const prevButton = document.createElement("button");
							prevButton.classList.add("custom-prev");
							prevButton.textContent = "Prev"; // Or use an icon
							customArrowsContainer.appendChild(prevButton);
						}
						if (
							!customArrowsContainer.querySelector(".custom-next")
						) {
							const nextButton = document.createElement("button");
							nextButton.classList.add("custom-next");
							nextButton.textContent = "Next"; // Or use an icon
							customArrowsContainer.appendChild(nextButton);
						}

						const prevButton =
							customArrowsContainer.querySelector(".custom-prev");
						const nextButton =
							customArrowsContainer.querySelector(".custom-next");
						// add event listener if buttons exists
						if (prevButton) {
							prevButton.addEventListener("click", () => {
								splideInstance.go("-1");
							});
						}
						if (nextButton) {
							nextButton.addEventListener("click", () => {
								splideInstance.go("+1");
							});
						}
					}
				}
			});
		}
	}

	//Initialize slider for team which has an unique ID
	//Any other blocks which use similar style of slide can be initilzed from here
	// News & PR archive featured story (KWB-82). Only ever mounted when the
	// archive is configured with more than one featured post — the comps draw a
	// single story with no dots or arrows, so one story stays flat markup.
	initializeSimpleSlider(".archive-featured__slider");
	initializeSimpleSlider(".dual-section__slider");
	initializeSimpleSlider(".highlight-carousel__slider");
	initializeSimpleSlider(".cabins-carousel__slider");
});
